import { dateFilterTypesListWithCustom } from "features/loads/components/LoadsDashboard/loadsDashboardConsts";
import { fieldTypes } from "services/filterService";

export const getFilterConfigs = ({ lots, clients, tenantName }) => [
    ...(clients?.length > 1 ? [{
        type: fieldTypes.LIST,
        size: 4,
        title: 'Client',
        key: 'clientId',
        values: [{ id: '', name: 'All clients' }, ...(clients ?? [])]
    }] : []),
    {
        type: fieldTypes.LIST,
        size: 4,
        title: 'Lot Type',
        key: 'lotFilter',
        values: [
            { id: 'all', name: 'All Lots' },
            { id: 'tenant', name: `${tenantName} Lots` },
            { id: 'washRule', name: 'Lots With Wash Rule' }
        ]
    },
    {
        type: fieldTypes.LOT,
        size: 4,
        title: 'Lot',
        key: 'lotId',
        values: lots,
        withTypeAhead: true
    }
];

export const getWashFilterConfigs = ({ activityItems }) => [
    {
        type: fieldTypes.LIST,
        title: 'Activity',
        key: 'activityItemId',
        values: activityItems?.map(item => ({ id: item.id, name: item.name })) || [],
        showEmpty: true
    },
    {
        type: fieldTypes.LIST,
        size: 3,
        title: 'Auto Generated',
        key: 'autoGenerated',
        values: [
            { id: 'all', name: 'All Washes' },
            { id: 'true', name: 'Auto Generated' },
            { id: 'false', name: 'Manual' }
        ]
    },
    {
        type: fieldTypes.LIST,
        size: 3,
        title: 'Filter Date by',
        key: 'dateFilterType',
        values: dateFilterTypesListWithCustom
    },
    {
        type: fieldTypes.LIST,
        size: 3,
        title: 'Specific date',
        key: 'dateFilter',
        values: []
    }
];
